import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { palette } from "../../../assets/styles/Palette";
import AtomPersonaLoader from "../../Global/components/atoms/AtomPersonaLoader";
import { Button } from "../../../assets/styles/ButtonStyle";
import images from "../../../assets/styles/Images";
import PopupWrap from "../../../assets/styles/Popup";

// 국기 이미지 import
import KoreaFlag from "../../../assets/images/NationalFlag/Korea.png";
import VietnamFlag from "../../../assets/images/NationalFlag/Vietnam.png";
import AmericaFlag from "../../../assets/images/NationalFlag/America.png";
import JapanFlag from "../../../assets/images/NationalFlag/Japan.png";
import ChinaFlag from "../../../assets/images/NationalFlag/China.png";
import ThailandFlag from "../../../assets/images/NationalFlag/Thailand.png";
import UzbekistanFlag from "../../../assets/images/NationalFlag/Uzbekistan.png";
import PhilippinesFlag from "../../../assets/images/NationalFlag/Philippines.png";
import RussiaFlag from "../../../assets/images/NationalFlag/Russia.png";
import {
  ContentsWrap,
  MainContent,
  TabContent5,
  TabContent5Item,
  DropzoneStyles,
  InterviewPopup,
} from "../../../assets/styles/BusinessAnalysisStyle";
import {
  H4,
  H3,
  Body2,
  Body3,
  InputText,
} from "../../../assets/styles/Typography";
import {
  FormBox,
  CustomTextarea,
  SelectBox,
  SelectBoxItem,
  SelectBoxTitle,
  SelectBoxList,
} from "../../../assets/styles/InputStyle";
import "react-dropzone-uploader/dist/styles.css";
import { useDynamicViewport } from "../../../assets/DynamicViewport";
import MoleculeFileUpload from "../components/molecules/MoleculeFileUpload";
import OrganismDesignConceptSelector from "../components/organisms/OrganismDesignConceptSelector";
import MoleculeAnalysisCard from "../components/molecules/MoleculeAnalysisCard";
import MoleculeCreateDisplayHeader from "../components/molecules/MoleculeCreateDisplayHeader";
import {
  IS_LOGGED_IN,
  AUTODISPLAY_DISPLAY_LIST,
  CUSTOMER_ID,
  AUTODISPLAY_EDITING_STATE,
  AUTODISPLAY_CONTENT_DATA,
  AUTODISPLAY_CONTENT_TARGET,
  AUTODISPLAY_DESIGN_SELECTED_CONCEPT,
  AUTODISPLAY_INTERVIEW_MODE_TYPE,
  AUTODISPLAY_MESSAGE,
  AUTODISPLAY_SELECTED_MESSAGE,
  AUTODISPLAY_TEXT_DATA,
  AUTODISPLAY_UPLOAD_FILE_DATA,
  AUTODISPLAY_UPLOAD_TYPE,
  AUTODISPLAY_VIEW_DEVICE,
  AUTODISPLAY_UPLOAD_TEXT_DATA,
  AUTODISPLAY_SELECTED_CONTENT_ID,
  AUTODISPLAY_LOCATION_DATA,
  AUTODISPLAY_DESIGN_CONCEPT,
  AUTODISPLAY_TITLE,
  AUTODISPLAY_SENSOR_DATA,
  USER_ORGANIZATION_TYPE,
} from "../../AtomStates";
import { useAtom } from "jotai";
import {
  AutoDisplaySummaryContentGeneratorMultimodalRequest,
  AutoDisplaySummaryContentGeneratorRequest,
  createDeviceOnServer,
  updateDeviceOnServer,
  getViewCustomDetailOnServer,
  getViewApiDetailOnServer,
  getUserMemberType,
} from "../../../utils/indexedDB";
import MoleculeMessageCard from "../components/molecules/MoleculeMessageCard";
import kmaRegionData from "../../../assets/data/kmaRegionData.json";
import OrganismInfoDisplayViewCustomPreview from "../../Global/components/organisms/OrganismInfoDisplayViewCustomPreview";

const designConceptsData = [
  {
    id: "라이트 모드",
    name: "라이트 모드",
    description: "기본 구성으로 정보 전달에 집중된 스타일입니다. ",
  },
  {
    id: "다크 모드",
    name: "다크 모드",
    description: "어두운 배경에 포인트 컬러로 정보 전달을 강조한 디자인입니다.",
  },
];

const PageCreateInfoDevice = () => {
  const navigate = useNavigate();

  const [userOrganizationType] = useAtom(USER_ORGANIZATION_TYPE);
  const [, setSensorSerialData] = useAtom(AUTODISPLAY_SENSOR_DATA);
  const [textData, setTextData] = useAtom(AUTODISPLAY_TEXT_DATA);
  const [, setLocationData] = useAtom(AUTODISPLAY_LOCATION_DATA);
  const [, setDesignConcept] = useAtom(AUTODISPLAY_DESIGN_CONCEPT);
  const [, setTitle] = useAtom(AUTODISPLAY_TITLE);
  const [editingAutoDisplay, setEditingAutoDisplay] = useAtom(
    AUTODISPLAY_EDITING_STATE
  );
  const [autoDisplayContentData] = useAtom(AUTODISPLAY_CONTENT_DATA);
  const [autoDisplayContentTarget] = useAtom(AUTODISPLAY_CONTENT_TARGET);
  const [autoDisplayDesignSelectedConcept] = useAtom(
    AUTODISPLAY_DESIGN_SELECTED_CONCEPT
  );
  const [autoDisplayInterviewModeType] = useAtom(
    AUTODISPLAY_INTERVIEW_MODE_TYPE
  );
  const [autoDisplayMessage] = useAtom(AUTODISPLAY_MESSAGE);
  const [autoDisplaySelectedMessage] = useAtom(AUTODISPLAY_SELECTED_MESSAGE);
  const [autoDisplayTextData] = useAtom(AUTODISPLAY_TEXT_DATA);
  const [autoDisplayUploadFileData] = useAtom(AUTODISPLAY_UPLOAD_FILE_DATA);
  const [autoDisplayUploadType] = useAtom(AUTODISPLAY_UPLOAD_TYPE);
  const [autoDisplayViewDevice] = useAtom(AUTODISPLAY_VIEW_DEVICE);
  const [autoDisplayUploadTextData] = useAtom(AUTODISPLAY_UPLOAD_TEXT_DATA);
  const [isLoggedIn] = useAtom(IS_LOGGED_IN);
  const [autoDisplaySelectedContentId, setAutoDisplaySelectedContentId] =
    useAtom(AUTODISPLAY_SELECTED_CONTENT_ID);
  const [customerId] = useAtom(CUSTOMER_ID);
  // UI 상태 관리
  const [showPopupError, setShowPopupError] = useState(false);
  const [activeTab, setActiveTab] = useState(1);
  const [completedSteps, setCompletedSteps] = useState([]);
  const [businessDescription, setBusinessDescription] = useState("");
  const [textUpload, setTextUpload] = useState("");
  const [contentTarget, setContentTarget] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showPopupFileSize, setShowPopupFileSize] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [fileNames, setFileNames] = useState([]);
  const [interviewModeType, setInterviewModeType] = useState("");
  const [showCreditPopup, setShowCreditPopup] = useState(false);
  const [selectedDesignConcepts, setSelectedDesignConcepts] = useState([]);
  const [uploadType, setUploadType] = useState("imageUpload");
  const [showResetPopup, setShowResetPopup] = useState(false);
  const [selectBoxStates, setSelectBoxStates] = useState({
    sensorDataList: false,
    languageList: false,
  });
  const [selectedPurposes, setSelectedPurposes] = useState({
    openDataList: "",
    sensorDataList: "",
    customerList: "",
  });

  const [showPreviewPopup, setShowPreviewPopup] = useState(false);
  const [autoDisplayFileAnalysis, setAutoDisplayFileAnalysis] = useState(null);
  const [timeStamp, setTimeStamp] = useState(null);
  const [messages, setMessages] = useState(null);
  const [editId, setEditId] = useState(null);
  const [editText, setEditText] = useState("");
  const [editOriginalText, setEditOriginalText] = useState("");
  const [serialCode, setSerialCode] = useState("");
  const [sensorDataName, setSensorDataName] = useState("");
  const [selectedDisplay, setSelectedDisplay] = useState("");
  const openDataListRef = useRef(null);
  const [displayList] = useAtom(AUTODISPLAY_DISPLAY_LIST);
  const [isLoadingMessage, setIsLoadingMessage] = useState(false);
  const [contentTitle, setContentTitle] = useState("");
  const [dataType, setDataType] = useState("sensor"); // 'sensor' or 'public'
  const [selectedRegion, setSelectedRegion] = useState(""); // 시/도
  const [selectedDistricts, setSelectedDistricts] = useState(""); // 또는 null
  const [isEditing, setIsEditing] = useState(false);
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [isEditingAutoDisplayImage, setIsEditingAutoDisplayImage] =
    useState(false);
  const [isEditingAutoDisplay, setIsEditingAutoDisplay] = useState(false);
  const [showSensorPreview, setShowSensorPreview] = useState(false);
  const [createViewId, setCreateViewId] = useState("");

  const languageList = [
    { name: "한국어", flag: KoreaFlag },
    { name: "베트남어", flag: VietnamFlag },
    { name: "영어", flag: AmericaFlag },
    { name: "일본어", flag: JapanFlag },
    { name: "중국어", flag: ChinaFlag },
    { name: "태국어", flag: ThailandFlag },
    { name: "우즈베크어", flag: UzbekistanFlag },
    { name: "필리핀어", flag: PhilippinesFlag },
    { name: "러시아어", flag: RussiaFlag },
  ];

  const openDataList = [
    {
      id: 1,
      title: "기상청 날씨 정보 (온도, 풍속, 습도 등 정보 노출)  ",
    },
  ];

  const [selectedLanguage, setSelectedLanguage] = useState(
    languageList.find((lang) => lang.name === "한국어")
  ); // '한국어' 기본 선택

  const regionNames = Object.keys(kmaRegionData); // ["서울특별시", "부산광역시", ...]
  const districtList = selectedRegion
    ? kmaRegionData[selectedRegion].map((item) => item.district)
    : [];

  const sensorDataList = [
    {
      id: 1,
      title: "기상청 날씨 정보 (온도, 습도, 등등 정보 노출)",
    },
    // {
    //   id: 2,
    //   title: "공공데이터 사용 안함",
    // },
  ];

  useDynamicViewport("width=1280");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const autoDisplayLoading = async () => {
      if (!editingAutoDisplay) return;
      if (editingAutoDisplay) {
        setIsEditingAutoDisplay(true);

        if (
          autoDisplaySelectedContentId &&
          autoDisplaySelectedContentId.length > 0
        ) {
          setAutoDisplaySelectedContentId(autoDisplaySelectedContentId);
        }
        if (
          autoDisplayContentData &&
          Object.keys(autoDisplayContentData).length > 0
        ) {
          setContentTitle(autoDisplayContentData?.title);
          setSerialCode(autoDisplayContentData?.serialCode);
          setSensorDataName(autoDisplayContentData?.sensorDataName);
          setDataType(autoDisplayContentData?.dataType);
          setSelectedPurposes((prev) => ({
            ...prev,
            sensorDataList: autoDisplayContentData?.sensorData,
            openDataList: autoDisplayContentData?.openData,
          }));

          setSelectedRegion(autoDisplayContentData?.selectedRegion);
          setSelectedDistricts(
            autoDisplayContentData?.selectedDistricts?.district || ""
          );
        }

        if (autoDisplayContentTarget.length > 0) {
          setContentTarget(autoDisplayContentTarget);
        }

        if (
          autoDisplayDesignSelectedConcept &&
          autoDisplayDesignSelectedConcept.length > 0
        ) {
          setSelectedDesignConcepts(autoDisplayDesignSelectedConcept);
        }

        if (autoDisplayInterviewModeType.length > 0) {
          setInterviewModeType(autoDisplayInterviewModeType);
        }

        // 메시지 초기화: text-only 구조와 original/translate 구조 모두 지원
        if (autoDisplayMessage && autoDisplayMessage.length > 0) {
          const normalized = autoDisplayMessage.map((m, idx) => {
            const hasTranslate = Object.prototype.hasOwnProperty.call(
              m,
              "translate"
            );
            const hasText = Object.prototype.hasOwnProperty.call(m, "text");
            return hasTranslate || !hasText
              ? m
              : {
                  id: m.id ?? idx + 1,
                  original: null,
                  translate: m.text,
                };
          });
          setMessages(normalized);
        }

        if (
          autoDisplaySelectedMessage &&
          Object.keys(autoDisplaySelectedMessage).length > 0
        ) {
          // 선택된 메시지도 text-only 구조 대응
          if (
            Object.prototype.hasOwnProperty.call(
              autoDisplaySelectedMessage,
              "text"
            ) &&
            !Object.prototype.hasOwnProperty.call(
              autoDisplaySelectedMessage,
              "translate"
            )
          ) {
            setSelectedMessage({
              id: autoDisplaySelectedMessage.id,
              original: null,
              translate: autoDisplaySelectedMessage.text,
            });
          } else {
            setSelectedMessage(autoDisplaySelectedMessage);
          }
        }

        if (autoDisplayTextData && autoDisplayTextData.length > 0) {
          setBusinessDescription(autoDisplayTextData);
        }

        if (autoDisplayUploadFileData && autoDisplayUploadFileData.length > 0) {
          const filesArray = Array.isArray(autoDisplayUploadFileData)
            ? autoDisplayUploadFileData
            : autoDisplayUploadFileData
            ? [autoDisplayUploadFileData]
            : [];

          setFileNames(filesArray.map((f) => f.name));

          if (autoDisplayInterviewModeType === "conceptBoard") {
            setIsEditingAutoDisplayImage(true);
          }
        }

        // if (autoDisplayUploadedFiles && autoDisplayUploadedFiles.length > 0) {

        //   setUploadedFiles(autoDisplayUploadedFiles);
        // }

        if (autoDisplayUploadType && autoDisplayUploadType.length > 0) {
          setUploadType(autoDisplayUploadType);
        }

        if (autoDisplayUploadTextData && autoDisplayUploadTextData.length > 0) {
          setTextUpload(autoDisplayUploadTextData);
        }

        if (
          autoDisplayViewDevice &&
          displayList &&
          Array.isArray(displayList)
        ) {
          const matched = displayList.find(
            (item) => item._id === autoDisplayViewDevice._id
          );
          if (matched) {
            setSelectedDisplay(matched);
          }
        }
      }
    };
    autoDisplayLoading();
    setEditingAutoDisplay(false);
  }, [editingAutoDisplay]);

  useEffect(() => {
    const checkMemberType = async () => {
      const accessToken = sessionStorage.getItem("accessToken");
      const userMemberType = await getUserMemberType(accessToken);
      const lastUrl = sessionStorage.getItem("lastUrl");

      if (
        (lastUrl === "/CreateContent" || lastUrl === "/DashBoard") &&
        userMemberType.member_type === 99
      ) {
        navigate("/Admin");
      }

      if (userMemberType.member_type === 11) {
        navigate("/DashBoard");
      } else if (userMemberType.member_type === 12) {
        navigate("/CustomerManage");
      } else if (userMemberType.member_type === 31) {
        navigate("/EducationDashBoard");
      } else if (userMemberType.member_type === 32) {
        navigate("/EduboardManage");
      }
    };

    checkMemberType();
  }, []);

  const handleOpenDataSelect = (type) => {
    setSelectedPurposes((prev) => ({
      ...prev,
      openDataList: type,
    }));
    setSelectBoxStates((prev) => ({
      ...prev,
      openDataList: false,
    }));
  };

  const handleNextStep = (currentStep) => {
    setCompletedSteps([...completedSteps, currentStep]);
    setActiveTab(currentStep + 1);
    setShowPopupError(false);
  };

  const handleSubmitConcept = async () => {
    handleNextStep(1);
  };

  const handleSelectBoxClick = (boxName) => {
    setSelectBoxStates((prev) => ({
      ...prev,
      [boxName]: !prev[boxName],
    }));
  };

  const handleSensorDataSelect = (type) => {
    setSelectedPurposes((prev) => ({
      ...prev,
      sensorDataList: type,
    }));
    setSelectBoxStates((prev) => ({
      ...prev,
      sensorDataList: false,
    }));
  };

  const handleSubmitPurpose = async () => {
    setIsLoadingMessage(true);

    try {
      let data;

      const timeStamp = new Date().getTime();
      setTimeStamp(timeStamp);

      if (uploadedFiles.length > 0 && uploadType === "imageUpload") {
        // 파일 업로드 모드 - 파일과 함께 전송

        data = {
          type: "auto_display_summary_content_generator_multimodal", // 필수
          // display_id: selectedDevice?._id || "", // 선택된 디스플레이 ID
          files: uploadedFiles,
          time_stamp: String(timeStamp),
          message_target: contentTarget,
          target_language: selectedLanguage.name,
        };

        let retryCount = 0;
        const maxRetries = 10;

        while (retryCount < maxRetries) {
          try {
            let response =
              await AutoDisplaySummaryContentGeneratorMultimodalRequest(
                data,
                isLoggedIn
              );

            if (
              response &&
              response.response &&
              response.response
                .auto_display_summary_content_generator_multimodal
            ) {
              const responseData =
                response.response
                  .auto_display_summary_content_generator_multimodal;
              // API 응답 데이터를 상태에 저장
              if (selectedLanguage.name === "한국어") {
                setMessages(
                  Object.entries(responseData).map(([key, value], idx) => ({
                    id: idx + 1,
                    original: null,
                    translate: value.translate,
                  }))
                );
              } else {
                setMessages(
                  Object.entries(responseData).map(([key, value], idx) => ({
                    id: idx + 1,
                    original: value.original,
                    translate: value.translate,
                  }))
                );
              }
              break; // 올바른 응답 형식이면 루프 종료
            }

            retryCount++;
          } catch (error) {
            console.error(`Retry ${retryCount + 1} failed:`, error);
            retryCount++;
            if (retryCount >= maxRetries) throw error;
          }
        }

        if (retryCount >= maxRetries) {
          throw new Error("텍스트 분석에 실패했습니다. 다시 시도해주세요.");
        }
      } else if (uploadedFiles.length === 0 && uploadType === "textUpload") {
        // 텍스트 입력 모드 - 텍스트만 전송
        data = {
          type: "auto_display_summary_content_generator", // 필수
          input_text: textUpload,
          message_target: contentTarget,
          target_language: selectedLanguage.name,
        };

        let retryCount = 0;
        const maxRetries = 10;

        while (retryCount < maxRetries) {
          try {
            let response = await AutoDisplaySummaryContentGeneratorRequest(
              data,
              isLoggedIn
            );

            if (
              response &&
              response.response &&
              response.response.auto_display_summary_content_generator
            ) {
              const responseData =
                response.response.auto_display_summary_content_generator;
              // API 응답 데이터를 상태에 저장
              if (selectedLanguage.name === "한국어") {
                setMessages(
                  Object.entries(responseData).map(([key, value], idx) => ({
                    id: idx + 1,
                    original: null,
                    translate: value.translate,
                  }))
                );
              } else {
                setMessages(
                  Object.entries(responseData).map(([key, value], idx) => ({
                    id: idx + 1,
                    original: value.original,
                    translate: value.translate,
                  }))
                );
              }
              break; // 올바른 응답 형식이면 루프 종료
            }

            retryCount++;
          } catch (error) {
            console.error(`Retry ${retryCount + 1} failed:`, error);
            retryCount++;
            if (retryCount >= maxRetries) throw error;
          }
        }

        if (retryCount >= maxRetries) {
          throw new Error("텍스트 분석에 실패했습니다. 다시 시도해주세요.");
        }
      }

      setCompletedSteps((prev) => [...prev, 3]);
    } catch (error) {
      console.error("콘텐츠 분석 중 오류 발생:", error);
      setShowPopupError(true);
    } finally {
      setIsLoading(false);
      setIsLoadingMessage(false);
    }
  };

  const handleChangeStatus = ({ meta, file, remove }, status) => {
    const maxSize = 20 * 1024 * 1024; // 20MB
    if (file.size > maxSize && status !== "removed") {
      setShowPopupFileSize(true);
      remove();
      return;
    }

    if (status === "done" || status === "preparing" || status === "uploading") {
      setUploadedFiles((prev) => {
        if (!prev.find((f) => f.name === file.name)) {
          setFileNames((prev) => [...prev, file.name]);
          return [...prev, file];
        }
        return prev;
      });
    } else if (status === "removed") {
      setUploadedFiles((prev) => prev.filter((f) => f.name !== file.name));
      setFileNames((prev) => prev.filter((name) => name !== file.name));
    }

    const size = file.size;
    const sizeStr =
      size > 1024 * 1024
        ? `${(size / (1024 * 1024)).toFixed(1)}MB`
        : `${(size / 1024).toFixed(1)}KB`;

    setTimeout(() => {
      const containers = document.querySelectorAll(".dzu-previewContainer");
      containers.forEach((container) => {
        if (!container.dataset.filename) {
          container.dataset.filename = file.name;
          container.dataset.size = sizeStr;

          if (file.type.startsWith("image/")) {
            if (!container.querySelector(".dzu-previewFileName")) {
              const nameSpan = document.createElement("span");
              nameSpan.className = "dzu-previewFileName";
              nameSpan.textContent = `${file.name}, ${sizeStr}`;

              if (container.firstChild) {
                container.insertBefore(nameSpan, container.firstChild);
              } else {
                container.appendChild(nameSpan);
              }
            }
          }
        }
      });
    }, 0);
  };

  const handleDesignConceptSelect = (conceptId) => {
    setSelectedDesignConcepts((prev) =>
      prev.includes(conceptId) ? [] : [conceptId]
    );
  };

  const handleDisplayConversion = async () => {
    handleNextStep(2);
  };

  const handleTemplatePreview = () => {
    setTitle(contentTitle);
    setTextData(
      interviewModeType === "conceptBoard"
        ? selectedMessage?.translate
        : textData
    );
    const locationData = {
      selectedRegion: selectedRegion,
      selectedDistricts: selectedDistricts,
    };
    setLocationData(locationData);
    setDesignConcept(selectedDesignConcepts);

    if (dataType === "sensor") {
      const sensorData = {
        title: contentTitle,
        serialCode: serialCode,
      };
      setSensorSerialData(sensorData);
    }

    if (dataType === "sensor") {
      setShowSensorPreview(true);
    }
  };

  const handleCloseSensorPreview = () => {
    setShowSensorPreview(false);
  };

  const handleConfirmContent = async () => {
    handleNextStep(3);

    try {
      let createViewId;

      createViewId = await createDeviceOnServer(isLoggedIn, customerId || null);
      setCreateViewId(createViewId);

      const selectedDistrictObject = kmaRegionData[selectedRegion]?.find(
        (d) => d.district === selectedDistricts
      );

      const now = new Date();

      const dateField =
        autoDisplaySelectedContentId.length > 0
          ? {
              updateDate: now.toLocaleString("ko-KR", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                hour12: true,
              }),
              updateTimestamp: now.getTime(),
            }
          : {
              createDate: now.toLocaleString("ko-KR", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                hour12: true,
              }),
              createTimestamp: now.getTime(),
            };

      // 저장 시 메시지 구조 표준화
      const formattedSelectedMessage = selectedMessage
        ? {
            id: selectedMessage.id,
            text: selectedMessage.original ? selectedMessage.translate + " / " + selectedMessage.original : selectedMessage.translate,
          }
        : null;

      // 데이터를 조합하여 contentData 객체 생성
      const contentData = {
        contentData: {
          title: contentTitle,
          serialCode: serialCode,
          sensorDataName: sensorDataName,
          dataType: dataType,
          sensorData: selectedPurposes.sensorDataList,
          openData: selectedPurposes.openDataList,
          selectedRegion: selectedRegion,
          selectedDistricts: selectedDistrictObject,
        },
        contentsType: "sensor",
        interviewModeType: interviewModeType,
        messages: messages,
        selectedMessage: formattedSelectedMessage,
        uploadType: uploadType,
        viewDevice: {
          _id: selectedDisplay?._id || "",
          deviceTitle: selectedDisplay?.deviceTitle || "",
          deviceDPI: selectedDisplay?.deviceSpec?.deviceDPI || "",
          deviceInch: selectedDisplay?.deviceSpec?.deviceInch || "",
          deviceCm: selectedDisplay?.deviceSpec?.deviceCm || "",
          deviceWidth: selectedDisplay?.deviceSpec?.deviceWidth || "",
          deviceHeight: selectedDisplay?.deviceSpec?.deviceHeight || "",
        },
        uploadFileData:
          autoDisplayUploadFileData.length > 0
            ? autoDisplayUploadFileData
            : uploadedFiles.map((file, index) => ({
                id: "file_" + timeStamp + "_" + (index + 1),
                name: file.name,
              })),

        uploadedFiles: uploadedFiles,
        textUpload: textUpload,
        textData: businessDescription,
        // dataAnalysis: {
        //   title: autoDisplayFileAnalysis?.title || "",
        //   source: autoDisplayFileAnalysis?.source || "",
        //   message: autoDisplayFileAnalysis?.message || "",
        //   detail: autoDisplayFileAnalysis?.detail || "",
        // },
        // contentsPurpose: selectedPurposes.customerList,
        contentsTarget: contentTarget,
        designSelectedConcept: selectedDesignConcepts,
        ...dateField,
      };

      if (customerId !== "") {
        contentData.customer = customerId;
      }

      await updateDeviceOnServer(createViewId, contentData);
    } catch (error) {
      console.error("콘텐츠 확인 또는 업데이트 실패:", error);
    }
  };

  const handleGoBack = async () => {
    try {
      // 현재 저장된 데이터를 가져온다
      let currentData;
      const currentViewId = createViewId;

      if (dataType === "sensor") {
        currentData = await getViewCustomDetailOnServer(
          currentViewId,
          isLoggedIn
        );
      } else if (dataType === "public") {
        currentData = await getViewApiDetailOnServer(currentViewId, isLoggedIn);
      }

      console.log("currentData", currentData);

      if (
        currentData &&
        currentData.activateCode &&
        Array.isArray(currentData.activateCode)
      ) {
        // activateCode 배열에서 state와 activeState가 1인 항목들의 updateState를 1로 변경
        const updatedActivateCode = currentData.activateCode.map((item) => {
          if (item.state === 1 && item.activeState === 1) {
            return {
              ...item,
              updateState: 1,
            };
          }
          return item;
        });

        // 기존 데이터 유지하면서 activateCode만 업데이트
        const updateData = {
          ...currentData,
          activateCode: updatedActivateCode,
        };

        // 데이터 타입에 따라 적절한 업데이트 함수 호출
        await updateDeviceOnServer(currentViewId, updateData);

        // console.log("activateCode 업데이트 완료:", updatedActivateCode);
      }

      // 완료 후 페이지 이동
      navigate("/InfoDashBoard");
    } catch (error) {
      console.error("돌아가기 처리 중 오류 발생:", error);
      // 오류가 발생해도 페이지는 이동
      navigate("/InfoDashBoard");
    }
  };

  const handleEdit = (id) => {
    setIsEditing(true);
    const msg = messages.find((m) => m.id === id);
    setEditId(id);
    setEditText(msg.translate ?? msg.text ?? "");
    setEditOriginalText(msg.original ?? "");
  };

  const handleEditComplete = (id) => {
    setMessages(
      messages.map((m) => {
        if (m.id !== id) return m;
        // text-only 구조인 경우 translate로 승격 저장
        const hasTranslate = Object.prototype.hasOwnProperty.call(
          m,
          "translate"
        );
        if (!hasTranslate && Object.prototype.hasOwnProperty.call(m, "text")) {
          return {
            ...m,
            translate: editText,
            original: editOriginalText ?? null,
          };
        }
        return {
          ...m,
          translate: editText,
          original: editOriginalText ?? m.original,
        };
      })
    );

    if (selectedMessage && selectedMessage.id === id) {
      setSelectedMessage({
        ...selectedMessage,
        translate: editText,
        original: editOriginalText ?? selectedMessage.original ?? null,
      });
    }
    setEditId(null);
    setIsEditing(false);
  };

  const handleResetAllState = () => {
    setMessages([]);
    setInterviewModeType("explanation");
    setEditId(null);
    setEditText("");
    setContentTarget("");
    setTextUpload("");
    setBusinessDescription("");
    setUploadType("imageUpload");
    setFileNames([]);
    setShowResetPopup(false);
  };

  const getStep1Values = () => {
    const base = {
      contentTitle,
      display: selectedDisplay,
      dataType,
    };

    const isNoPublicData =
      selectedPurposes?.sensorDataList === "공공데이터 사용 안함";
    return {
      ...base,
      serialCode,
      sensorDataName,
      sensorDataList: selectedPurposes?.sensorDataList,
      ...(isNoPublicData
        ? {}
        : {
            region: selectedRegion,
            district: selectedDistricts || "",
          }),
    };
  };
  const isStep1Valid = () => {
    const value = getStep1Values();
    
    // dataType이 "sensor"인 경우: 센서 관련 필드 필수
    if (value.dataType === "sensor") {
      return (
        value.contentTitle &&
        value.dataType &&
        value.serialCode &&
        value.sensorDataName &&
        value.sensorDataList &&
        (value.sensorDataList === "공공데이터 사용 안함" ||
          (value.region && value.district))
      );
    }
    
    // dataType이 "public"인 경우: 제목, dataType, 지역 필수
    if (value.dataType === "public") {
      return (
        value.contentTitle &&
        value.dataType &&
        value.region &&
        value.district
      );
    }
    
    return false;
  };

  useEffect(() => {
    // 새로고침 감지 함수
    const detectRefresh = () => {
      // 현재 URL 확인
      const currentUrl = window.location.href;
      if (currentUrl.toLowerCase().includes("createapicontent")) {
        // 세션 스토리지에서 마지막 URL 가져오기
        const lastUrl = sessionStorage.getItem("lastUrl");

        // 마지막 URL이 현재 URL과 같으면 새로고침
        if (lastUrl && lastUrl === currentUrl) {
          navigate("/InfoDashBoard");
          return true;
        }

        // 현재 URL 저장
        sessionStorage.setItem("lastUrl", currentUrl);
      }

      return false;
    };

    // F5 키 또는 Ctrl+R 감지
    const handleKeyDown = (event) => {
      if (
        (event.key === "r" && (event.metaKey || event.ctrlKey)) ||
        event.key === "F5"
      ) {
        // F5 키 코드
        event.preventDefault();

        navigate("/InfoDashBoard");
      }
    };

    // 함수 실행
    detectRefresh();

    // 이벤트 리스너 등록
    window.addEventListener("keydown", handleKeyDown);

    // 컴포넌트 언마운트 시 이벤트 리스너 제거
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [navigate]);

  const handleLanguageSelect = (lang) => {
    setSelectedLanguage(lang);
    setSelectBoxStates((prev) => ({ ...prev, languageList: false }));
  };

  return (
    <>
      <DropzoneStyles />
      <ContentsWrap>
        <MoleculeCreateDisplayHeader
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          completedSteps={completedSteps}
          isLoading={isLoading}
          isMessageLoading={isLoadingMessage}
          // onPreview={handleTemplatePreview}
          onSubmitConcept={handleSubmitConcept}
          onSubmitReport={handleSubmitPurpose}
          onDisplayConversion={handleDisplayConversion}
          // hasContentDraft={showTemplateSelection}
          onConfirmContent={handleConfirmContent}
          // 1단계에서 파일 업로드나 텍스트 입력이 있는지 확인
          canProceedFromStep1={activeTab === 1 ? isStep1Valid() : true}
          canProceedFromStep2={
            activeTab === 2
              ? (interviewModeType === "conceptBoard" &&
                  ((uploadType === "imageUpload" &&
                    fileNames &&
                    fileNames.length > 0) ||
                    (uploadType === "textUpload" &&
                      textUpload &&
                      textUpload.trim().length > 0)) &&
                  contentTarget &&
                  contentTarget.trim().length > 0 &&
                  // 메시지가 있을 때는 selectedMessage도 반드시 있어야 함
                  (!messages?.length || !!selectedMessage)) ||
                (interviewModeType === "explanation" &&
                  businessDescription &&
                  businessDescription.trim().length > 0)
              : true
          }
          canProceedFromStep3={
            activeTab === 3 &&
            !!selectedDesignConcepts &&
            selectedDesignConcepts.length > 0
              ? true
              : false
          }
          isCreatedMessage={false}
          setMessages={setMessages}
          setInterviewModeType={setInterviewModeType}
          setEditId={setEditId}
          setEditText={setEditText}
          messages={messages}
          selectedMessage={selectedMessage}
          interviewModeType={interviewModeType}
        />

        <MainContent Wide1030>
          <DesignAnalysisWrap>
            {activeTab === 1 && (
              <TabContent5>
                <div className="content">
                  <TabContent5Item required>
                    <div style={{ height: "20px" }}></div> {/* 간격용 div */}
                    <H3
                      color="gray800"
                      style={{ textAlign: "left", marginBottom: "30px" }}
                    >
                      콘텐츠 연결에 필요한 기본 정보를 입력하세요{" "}
                    </H3>
                    <AddDisplaySection>
                      <InputGroup>
                        <Label>콘텐츠 명</Label>
                        <FormBox Large>
                          <CustomTextarea
                            Edit
                            rows={1}
                            placeholder="디스플레이 화면에 보여질 콘텐츠 이름을 작성해주세요 (예: 로비 A - 날씨 정보 등), 최대 25자"
                            value={contentTitle}
                            onChange={(e) => {
                              if (e.target.value.length <= 25) {
                                setContentTitle(e.target.value);
                              }
                            }}
                            maxLength={25}
                            status="valid"
                          />
                        </FormBox>
                      </InputGroup>

                      <RadioGroup style={{ marginTop: "20px" }}>
                        <RadioButton checked={dataType === "sensor"}>
                          <input
                            type="radio"
                            name="dataType"
                            value="sensor"
                            checked={dataType === "sensor"}
                            onChange={() => {
                              setDataType("sensor");
                              setSelectedRegion("");
                              setSelectedDistricts("");
                            }}
                            disabled={
                              isEditingAutoDisplay && dataType === "public"
                            }
                          />
                          센서 데이터 연동 전용
                        </RadioButton>

                        <RadioButton checked={dataType === "public"}>
                          <input
                            type="radio"
                            name="dataType"
                            value="public"
                            checked={dataType === "public"}
                            onChange={() => {
                              setDataType("public");
                              setSerialCode("");
                              setSensorDataName("");
                              setSelectedPurposes({});
                              setSelectedRegion("");
                              setSelectedDistricts("");
                            }}
                            disabled={
                              isEditingAutoDisplay && dataType === "sensor"
                            }
                          />
                          공공 데이터 전용
                        </RadioButton>
                      </RadioGroup>

                      {dataType === "sensor" && (
                        <>
                            <InputRow>
                              <HalfInputGroup>
                                <Label>센서 코드 정보</Label>
                                <FormBox Large>
                                  <CustomTextarea
                                    Edit
                                    rows={1}
                                    placeholder="센서 시리얼 정보를 입력하세요 "
                                    value={serialCode}
                                    onChange={(e) =>
                                      setSerialCode(e.target.value)
                                    }
                                    status="valid"
                                  />
                                </FormBox>
                              </HalfInputGroup>
                              <HalfInputGroup>
                                <Label>센서데이터 명</Label>
                                <FormBox Large>
                                  <CustomTextarea
                                    Edit
                                    rows={1}
                                    placeholder="콘텐츠 리스트에서 확인할 데이터 이름을 작성해주세요"
                                    value={sensorDataName}
                                    onChange={(e) =>
                                      setSensorDataName(e.target.value)
                                    }
                                    status="valid"
                                  />
                                </FormBox>
                              </HalfInputGroup>
                            </InputRow>

                          <div
                            className="title"
                            style={{ marginBottom: "-15px" }}
                          >
                            <Body3 color="gray700">공공데이터 선택</Body3>
                          </div>
                          <SelectBox
                            ref={openDataListRef}
                            style={{ marginBottom: "-10px" }}
                          >
                            <SelectBoxTitle
                              onClick={() =>
                                handleSelectBoxClick(
                                  "sensorDataList",
                                  openDataListRef
                                )
                              }
                            >
                              <Body2
                                color={
                                  selectedPurposes.sensorDataList
                                    ? "gray800"
                                    : "gray300"
                                }
                              >
                                {selectedPurposes.sensorDataList ||
                                  "선택해주세요"}
                              </Body2>
                              <images.ChevronDown
                                width="24px"
                                height="24px"
                                color={palette.gray500}
                                style={{
                                  transform: selectBoxStates.sensorDataList
                                    ? "rotate(180deg)"
                                    : "rotate(0deg)",
                                  transition: "transform 0.3s ease",
                                }}
                              />
                            </SelectBoxTitle>
                            {selectBoxStates.sensorDataList && (
                              <SelectBoxList
                                dropUp={false}
                                style={{ zIndex: "1000" }}
                              >
                                {sensorDataList.map((data) => (
                                  <SelectBoxItem
                                    key={data.id}
                                    onClick={() =>
                                      handleSensorDataSelect(data.title)
                                    }
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <input
                                      type="radio"
                                      name="sensorDataSelect"
                                      checked={
                                        selectedPurposes.sensorDataList ===
                                        data.title
                                      }
                                      readOnly
                                      style={{
                                        marginRight: "12px",
                                        width: "16px",
                                        height: "16px",
                                      }}
                                    />
                                    <Body2 color="gray700" align="left">
                                      {data.title}
                                    </Body2>
                                  </SelectBoxItem>
                                ))}
                                <div
                                  style={{
                                    width: "100%",
                                    textAlign: "center",
                                    color: "#8A949E",
                                    fontSize: "14px",
                                    padding: "12px 0 4px 0",
                                    borderTop: "1px solid #E0E4EB",
                                    background: "#fff",
                                    marginBottom: "10px",
                                  }}
                                >
                                  공공데이터는 지속적으로 추가 예정입니다.
                                </div>
                              </SelectBoxList>
                            )}
                          </SelectBox>

                          {selectedPurposes.sensorDataList ===
                            "기상청 날씨 정보 (온도, 습도, 등등 정보 노출)" && (
                            <DoubleSelectRow style={{ marginTop: "10px" }}>
                              <div style={{ flex: 1, position: "relative" }}>
                                <Body3
                                  color="gray700"
                                  style={{
                                    marginBottom: "8px",
                                    textAlign: "left",
                                  }}
                                >
                                  지역 선택
                                </Body3>
                                <HalfSelectBox>
                                  <SelectBoxTitle
                                    onClick={() =>
                                      handleSelectBoxClick("region")
                                    }
                                  >
                                    <Body2
                                      color={
                                        selectedRegion ? "gray800" : "gray300"
                                      }
                                    >
                                      {selectedRegion
                                        ? selectedRegion
                                        : "선택해주세요"}
                                    </Body2>
                                    <images.ChevronDown
                                      width="24px"
                                      height="24px"
                                      color={palette.gray500}
                                      style={{
                                        transform: selectBoxStates.region
                                          ? "rotate(180deg)"
                                          : "rotate(0deg)",
                                        transition: "transform 0.3s ease",
                                      }}
                                    />
                                  </SelectBoxTitle>
                                  {selectBoxStates.region && (
                                    <SelectBoxList
                                      style={{
                                        zIndex: 1000,
                                        position: "absolute",
                                        width: "100%",
                                        maxHeight: "264px", // 44px * 6
                                        overflowY: "auto",
                                      }}
                                    >
                                      {regionNames.map((regionName, idx) => (
                                        <SelectBoxItem
                                          key={idx}
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            setSelectedRegion(regionName); // 단일 선택
                                            setSelectBoxStates((prev) => ({
                                              ...prev,
                                              region: false,
                                            })); // 선택 후 닫기
                                          }}
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                          }}
                                        >
                                          <input
                                            type="radio"
                                            name="regionSelect"
                                            checked={
                                              selectedRegion === regionName
                                            }
                                            readOnly
                                            style={{ marginRight: "8px" }}
                                          />
                                          <span
                                            style={{
                                              fontSize: "16px",
                                              color: "#222",
                                            }}
                                          >
                                            {regionName}
                                          </span>
                                        </SelectBoxItem>
                                      ))}
                                    </SelectBoxList>
                                  )}
                                </HalfSelectBox>
                              </div>
                              <div style={{ flex: 1, position: "relative" }}>
                                <Body3
                                  color="gray700"
                                  style={{
                                    marginBottom: "8px",
                                    textAlign: "left",
                                  }}
                                >
                                  시/군/구 선택
                                </Body3>
                                <HalfSelectBox>
                                  <SelectBoxTitle
                                    onClick={() =>
                                      handleSelectBoxClick("district")
                                    }
                                  >
                                    <Body2
                                      color={
                                        selectedDistricts.length > 0
                                          ? "gray800"
                                          : "gray300"
                                      }
                                    >
                                      {selectedDistricts || "선택해주세요"}
                                    </Body2>
                                    <images.ChevronDown
                                      width="24px"
                                      height="24px"
                                      color={palette.gray500}
                                      style={{
                                        transform: selectBoxStates.district
                                          ? "rotate(180deg)"
                                          : "rotate(0deg)",
                                        transition: "transform 0.3s ease",
                                      }}
                                    />
                                  </SelectBoxTitle>
                                  {selectBoxStates.district && (
                                    <SelectBoxList
                                      style={{
                                        zIndex: 1000,
                                        position: "absolute",
                                        width: "100%",
                                        maxHeight: "264px", // 44px * 6
                                        overflowY: "auto",
                                      }}
                                    >
                                      {districtList.map((district, idx) => (
                                        <SelectBoxItem
                                          key={district}
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            setSelectedDistricts(district); // 단일 선택
                                            setSelectBoxStates((prev) => ({
                                              ...prev,
                                              district: false,
                                            })); // 선택 후 닫기
                                          }}
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                          }}
                                        >
                                          <input
                                            type="radio"
                                            name="districtSelect"
                                            checked={selectedDistricts.includes(
                                              district
                                            )}
                                            readOnly
                                            style={{ marginRight: "8px" }}
                                          />
                                          <span
                                            style={{
                                              fontSize: "16px",
                                              color: "#222",
                                            }}
                                          >
                                            {district}
                                          </span>
                                        </SelectBoxItem>
                                      ))}
                                    </SelectBoxList>
                                  )}
                                </HalfSelectBox>
                              </div>
                            </DoubleSelectRow>
                          )}
                        </>
                      )}
                      {dataType === "public" && (
                        <>
                          <div
                            className="title"
                            style={{ marginBottom: "-15px" }}
                          >
                            <Body3 color="gray700">공공데이터 선택</Body3>
                          </div>
                          <SelectBox
                            ref={openDataListRef}
                            style={{ marginBottom: "-10px" }}
                          >
                            <SelectBoxTitle
                              onClick={() =>
                                handleSelectBoxClick(
                                  "openDataList",
                                  openDataListRef
                                )
                              }
                            >
                              <Body2
                                color={
                                  selectedPurposes.openDataList
                                    ? "gray800"
                                    : "gray300"
                                }
                              >
                                {selectedPurposes.openDataList ||
                                  "선택해주세요"}
                              </Body2>
                              <images.ChevronDown
                                width="24px"
                                height="24px"
                                color={palette.gray500}
                                style={{
                                  transform: selectBoxStates.openDataList
                                    ? "rotate(180deg)"
                                    : "rotate(0deg)",
                                  transition: "transform 0.3s ease",
                                }}
                              />
                            </SelectBoxTitle>
                            {selectBoxStates.openDataList && (
                              <SelectBoxList
                                dropUp={false}
                                style={{ zIndex: "1000" }}
                              >
                                {openDataList.map((data) => (
                                  <SelectBoxItem
                                    key={data.id}
                                    onClick={() => {
                                      handleOpenDataSelect(data.title);
                                      setSelectBoxStates((prev) => ({
                                        ...prev,
                                        openDataList: false,
                                      })); // 선택 후 닫기
                                    }}
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <input
                                      type="radio"
                                      name="openDataSelect"
                                      checked={
                                        selectedPurposes.openDataList ===
                                        data.title
                                      }
                                      readOnly
                                      style={{
                                        marginRight: "12px",
                                        width: "16px",
                                        height: "16px",
                                      }}
                                    />
                                    <Body2 color="gray700" align="left">
                                      {data.title}
                                    </Body2>
                                  </SelectBoxItem>
                                ))}
                                <div
                                  style={{
                                    width: "100%",
                                    textAlign: "center",
                                    color: "#8A949E",
                                    fontSize: "14px",
                                    padding: "12px 0 4px 0",
                                    borderTop: "1px solid #E0E4EB",
                                    background: "#fff",
                                    marginBottom: "10px",
                                  }}
                                >
                                  공공데이터는 지속적으로 추가 예정입니다.
                                </div>
                              </SelectBoxList>
                            )}
                          </SelectBox>

                          <DoubleSelectRow style={{ marginTop: "10px" }}>
                            <div style={{ flex: 1, position: "relative" }}>
                              <Body3
                                color="gray700"
                                style={{
                                  marginBottom: "8px",
                                  textAlign: "left",
                                }}
                              >
                                지역 선택
                              </Body3>
                              <HalfSelectBox>
                                <SelectBoxTitle
                                  onClick={() => handleSelectBoxClick("region")}
                                >
                                  <Body2
                                    color={
                                      selectedRegion ? "gray800" : "gray300"
                                    }
                                  >
                                    {selectedRegion
                                      ? selectedRegion
                                      : "선택해주세요"}
                                  </Body2>
                                  <images.ChevronDown
                                    width="24px"
                                    height="24px"
                                    color={palette.gray500}
                                    style={{
                                      transform: selectBoxStates.region
                                        ? "rotate(180deg)"
                                        : "rotate(0deg)",
                                      transition: "transform 0.3s ease",
                                    }}
                                  />
                                </SelectBoxTitle>
                                {selectBoxStates.region && (
                                  <SelectBoxList
                                    style={{
                                      zIndex: 1000,
                                      position: "absolute",
                                      width: "100%",
                                      maxHeight: "264px", // 44px * 6
                                      overflowY: "auto",
                                    }}
                                  >
                                    {regionNames.map((regionName, idx) => (
                                      <SelectBoxItem
                                        key={idx}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setSelectedRegion(regionName); // 단일 선택
                                          setSelectBoxStates((prev) => ({
                                            ...prev,
                                            region: false,
                                          })); // 선택 후 닫기
                                        }}
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        <input
                                          type="radio"
                                          name="regionSelect"
                                          checked={
                                            selectedRegion === regionName
                                          }
                                          readOnly
                                          style={{ marginRight: "8px" }}
                                        />
                                        <span
                                          style={{
                                            fontSize: "16px",
                                            color: "#222",
                                          }}
                                        >
                                          {regionName}
                                        </span>
                                      </SelectBoxItem>
                                    ))}
                                  </SelectBoxList>
                                )}
                              </HalfSelectBox>
                            </div>
                            <div style={{ flex: 1, position: "relative" }}>
                              <Body3
                                color="gray700"
                                style={{
                                  marginBottom: "8px",
                                  textAlign: "left",
                                }}
                              >
                                시/군/구 선택
                              </Body3>
                              <HalfSelectBox>
                                <SelectBoxTitle
                                  onClick={() =>
                                    handleSelectBoxClick("district")
                                  }
                                >
                                  <Body2
                                    color={
                                      selectedDistricts.length > 0
                                        ? "gray800"
                                        : "gray300"
                                    }
                                  >
                                    {selectedDistricts || "선택해주세요"}
                                  </Body2>
                                  <images.ChevronDown
                                    width="24px"
                                    height="24px"
                                    color={palette.gray500}
                                    style={{
                                      transform: selectBoxStates.district
                                        ? "rotate(180deg)"
                                        : "rotate(0deg)",
                                      transition: "transform 0.3s ease",
                                    }}
                                  />
                                </SelectBoxTitle>
                                {selectBoxStates.district && (
                                  <SelectBoxList
                                    style={{
                                      zIndex: 1000,
                                      position: "absolute",
                                      width: "100%",
                                      maxHeight: "264px", // 44px * 6
                                      overflowY: "auto",
                                    }}
                                  >
                                    {districtList.map((district, idx) => (
                                      <SelectBoxItem
                                        key={district}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setSelectedDistricts(district); // 단일 선택
                                          setSelectBoxStates((prev) => ({
                                            ...prev,
                                            district: false,
                                          })); // 선택 후 닫기
                                        }}
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        <input
                                          type="radio"
                                          name="districtSelect"
                                          checked={selectedDistricts.includes(
                                            district
                                          )}
                                          readOnly
                                          style={{ marginRight: "8px" }}
                                        />
                                        <span
                                          style={{
                                            fontSize: "16px",
                                            color: "#222",
                                          }}
                                        >
                                          {district}
                                        </span>
                                      </SelectBoxItem>
                                    ))}
                                  </SelectBoxList>
                                )}
                              </HalfSelectBox>
                            </div>
                          </DoubleSelectRow>
                        </>
                      )}
                    </AddDisplaySection>
                  </TabContent5Item>
                </div>
              </TabContent5>
            )}

            {activeTab === 2 && completedSteps.includes(1) && (
              <TabContent5>
                {isLoading ? (
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      minHeight: "200px",
                      alignItems: "center",
                    }}
                  >
                    <AtomPersonaLoader message="콘텐츠 핵심 내용을 AI로 분석하고 있어요" />
                    <div style={{ height: "520px" }}></div> {/* 간격용 div */}
                  </div>
                ) : (
                  <>
                    <div className="content">
                      <TabContent5Item required>
                        <div style={{ height: "20px" }}></div>{" "}
                        <InfoBox>
                          <div
                            style={{
                              fontWeight: "700",
                              marginBottom: "12px",
                              textAlign: "left",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <Body2 style={{ minWidth: 110 }}>콘텐츠 명</Body2>
                            <Body2 style={{ marginLeft: 16 }}>
                              {contentTitle}
                            </Body2>
                          </div>

                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <Body3 color="gray600" style={{ minWidth: 110 }}>
                              콘텐츠 타입
                            </Body3>
                            <Body3 color="gray800" style={{ marginLeft: 16 }}>
                              {dataType === "sensor" &&
                                `센서 데이터 연동 전용(${
                                  serialCode || "시리얼 넘버"
                                })`}
                              {dataType === "public" && "공공데이터 사용"}
                            </Body3>
                          </div>

                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              position: "relative",
                            }}
                          >
                            <Body3 color="gray600" style={{ minWidth: 110 }}>
                              언어 선택
                            </Body3>
                            <div
                              style={{
                                flex: 1,
                                marginLeft: 16,
                                position: "relative",
                              }}
                            >
                              <div
                                onClick={() =>
                                  handleSelectBoxClick("languageList")
                                }
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  padding: "8px 0",
                                  cursor: "pointer",
                                }}
                              >
                                <Body2
                                  color={
                                    selectedLanguage ? "gray800" : "gray300"
                                  }
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  {selectedLanguage ? (
                                    <>
                                      <img
                                        src={selectedLanguage.flag}
                                        alt={selectedLanguage.name}
                                        style={{
                                          width: "28px",
                                          height: "28px",
                                          marginRight: "8px",
                                          borderRadius: "50%",
                                          border: "1px solid #E0E4EB",
                                        }}
                                      />
                                      {selectedLanguage.name}
                                    </>
                                  ) : (
                                    "원하는 언어를 선택해주세요"
                                  )}
                                </Body2>
                                <images.ChevronDown
                                  width="24px"
                                  height="24px"
                                  color={palette.gray500}
                                  style={{
                                    transform: selectBoxStates.languageList
                                      ? "rotate(180deg)"
                                      : "rotate(0deg)",
                                    transition: "transform 0.3s ease",
                                  }}
                                />
                              </div>
                              {selectBoxStates.languageList && (
                                <SelectBoxList
                                  style={{
                                    width: "calc(100% + 126px)",
                                    left: "-126px",
                                    top: "50px",
                                  }}
                                >
                                  {languageList.map((lang, index) => (
                                    <SelectBoxItem
                                      key={index}
                                      onClick={() => handleLanguageSelect(lang)}
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        cursor: "pointer",
                                      }}
                                    >
                                      <input
                                        type="radio"
                                        name="languageSelect"
                                        checked={
                                          selectedLanguage?.name === lang.name
                                        }
                                        readOnly
                                        style={{
                                          marginRight: "12px",
                                          width: "16px",
                                          height: "16px",
                                        }}
                                      />
                                      <Body2
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        <img
                                          src={lang.flag}
                                          alt={lang.name}
                                          style={{
                                            width: "24px",
                                            height: "24px",
                                            marginRight: "8px",
                                            borderRadius: "50%",
                                            border: "1px solid #E0E4EB",
                                          }}
                                        />
                                        {lang.name}
                                      </Body2>
                                    </SelectBoxItem>
                                  ))}
                                </SelectBoxList>
                              )}
                            </div>
                          </div>
                        </InfoBox>
                        <ContentAnalysisSection>
                          <ContentOptionsSection>
                            <H3
                              color="gray800"
                              style={{
                                textAlign: "left",
                                marginTop: "20px",
                                marginBottom: "12px",
                              }}
                            >
                              디스플레이 하단에 표시할 메시지를 설정해보세요{" "}
                            </H3>
                          </ContentOptionsSection>
                        </ContentAnalysisSection>
                        <InterviewModeSelection
                          style={{ marginBottom: "30px" }}
                        >
                          <RadioCardGroup>
                            <RadioCard
                              checked={interviewModeType === "explanation"}
                            >
                              <RadioInput
                                type="radio"
                                name="interviewMode"
                                value="explanation"
                                checked={interviewModeType === "explanation"}
                                onChange={() => {
                                  setInterviewModeType("explanation");

                                  if (!messages?.length > 0) {
                                    setUploadedFiles([]);
                                    setFileNames([]);
                                    setUploadType("imageUpload");
                                    setContentTarget("");
                                    setTextUpload("");
                                  }
                                }}
                                disabled={isLoadingMessage}
                              />
                              <RadioTitle>
                                <CustomRadio
                                  checked={interviewModeType === "explanation"}
                                />
                                직접 작성하기
                              </RadioTitle>
                              <RadioDesc style={{ marginTop: "12px" }}>
                                원하는 문구를 직접 입력해보세요
                              </RadioDesc>
                            </RadioCard>
                            <RadioCard
                              checked={interviewModeType === "conceptBoard"}
                            >
                              <RadioInput
                                type="radio"
                                name="interviewMode"
                                value="conceptBoard"
                                checked={interviewModeType === "conceptBoard"}
                                onChange={() => {
                                  setInterviewModeType("conceptBoard");
                                  setBusinessDescription("");
                                }}
                                disabled={isLoadingMessage}
                              />
                              <RadioTitle>
                                <CustomRadio
                                  checked={interviewModeType === "conceptBoard"}
                                />
                                AI 메시지 제안받기
                              </RadioTitle>
                              <RadioDesc>
                                AI가 내용 분석후, 자동으로 문구를 제시합니다
                              </RadioDesc>
                            </RadioCard>
                          </RadioCardGroup>
                        </InterviewModeSelection>
                        {isLoadingMessage ? (
                          <div
                            style={{
                              width: "100%",
                              display: "flex",
                              justifyContent: "center",
                              minHeight: "200px",
                              alignItems: "center",
                            }}
                          >
                            <AtomPersonaLoader message="콘텐츠 핵심 내용을 AI로 분석하고 있어요" />
                          </div>
                        ) : Array.isArray(messages) &&
                          messages.length > 0 &&
                          interviewModeType !== "explanation" ? (
                          <div
                            style={{
                              width: "100%",
                              maxWidth: "820px",
                              margin: "0 auto",
                              display: "flex",
                              flexDirection: "column",
                              gap: "16px",
                              marginTop: "20px",
                            }}
                          >
                            {messages.map((msg) => (
                              <MoleculeMessageCard
                                key={msg.id}
                                id={msg.id}
                                editId={editId}
                                translatedText={
                                  editId === msg.id ? (
                                    <textarea
                                      rows="1"
                                      value={editText}
                                      onChange={(e) =>
                                        setEditText(e.target.value)
                                      }
                                      onInput={(e) => {
                                        e.target.style.height = "auto";
                                        e.target.style.height = `${e.target.scrollHeight}px`;
                                      }}
                                      autoFocus
                                      style={{
                                        fontSize: "16px",
                                        fontWeight: "700",
                                        width: "100%",
                                        border: "none",
                                        borderRadius: "4px",
                                        padding: "0",
                                        resize: "none",
                                        fontFamily: "inherit",
                                        background: "transparent",
                                        color: "#222",
                                        lineHeight: 1.5,
                                        overflow: "hidden",
                                        boxSizing: "border-box",
                                      }}
                                    />
                                  ) : (
                                    // 메시지 구조 호환: translate 우선, 없으면 text
                                    msg.translate ?? msg.text
                                  )
                                }
                                originalText={
                                  editId === msg.id && msg.original !== null ? (
                                    <textarea
                                      rows="1"
                                      value={editOriginalText}
                                      onChange={(e) =>
                                        setEditOriginalText(e.target.value)
                                      }
                                      onInput={(e) => {
                                        e.target.style.height = "auto";
                                        e.target.style.height = `${e.target.scrollHeight}px`;
                                      }}
                                      style={{
                                        fontSize: "14px",
                                        width: "100%",
                                        border: "none",
                                        borderRadius: "4px",
                                        padding: "0",
                                        resize: "none",
                                        color: "#888",
                                        fontFamily: "inherit",
                                        background: "transparent",
                                        lineHeight: 1.5,
                                        overflow: "hidden",
                                        boxSizing: "border-box",
                                      }}
                                    />
                                  ) : (
                                    // 메시지 구조 호환
                                    msg.original ?? null
                                  )
                                }
                                isSelected={msg.id === selectedMessage?.id}
                                onSelect={() => setSelectedMessage(msg)}
                                onEdit={handleEdit}
                                isEditing={isEditing}
                                setIsEditing={setIsEditing}
                                onEditComplete={handleEditComplete}
                                disabled={false}
                              />
                            ))}
                          </div>
                        ) : (
                          <>
                            {interviewModeType === "conceptBoard" && (
                              <div className="content">
                                <div
                                  className="title"
                                  style={{ marginBottom: "-35px" }}
                                >
                                  <Body3 color="gray700">메시지 대상자</Body3>
                                </div>
                                <FormBox
                                  Large
                                  style={{ marginBottom: "-10px" }}
                                >
                                  <CustomTextarea
                                    Edit
                                    rows={1}
                                    placeholder="작성해주세요"
                                    value={contentTarget}
                                    onChange={(e) =>
                                      setContentTarget(e.target.value)
                                    }
                                    status="valid"
                                  />
                                </FormBox>

                                <InterviewModeSelection>
                                  <Button
                                    Medium
                                    Outline
                                    style={{
                                      backgroundColor:
                                        uploadType === "imageUpload"
                                          ? "#F7F8FA"
                                          : "transparent",
                                      borderColor:
                                        uploadType === "imageUpload"
                                          ? "#E0E4EB"
                                          : "#E0E4EB",
                                    }}
                                    onClick={() => {
                                      setUploadType("imageUpload");
                                      setTextUpload("");
                                    }}
                                    // disabled={toolSteps >= 1 || isLoadingPreset}
                                  >
                                    <InputText color="gray700">
                                      파일 업로드
                                    </InputText>
                                  </Button>

                                  <Button
                                    Medium
                                    Outline
                                    style={{
                                      backgroundColor:
                                        uploadType === "textUpload"
                                          ? "#F7F8FA"
                                          : "transparent",
                                      borderColor:
                                        uploadType === "textUpload"
                                          ? "#E0E4EB"
                                          : "#E0E4EB",
                                    }}
                                    onClick={() => {
                                      setUploadType("textUpload");
                                      setFileNames([]);
                                      setUploadedFiles([]);
                                    }}
                                    // disabled={toolSteps >= 1 || isLoadingPreset}
                                  >
                                    <InputText color="gray700">
                                      텍스트로 작성
                                    </InputText>
                                  </Button>
                                </InterviewModeSelection>

                                {uploadType === "imageUpload" && (
                                  <MoleculeFileUpload
                                    fileNames={fileNames ?? []}
                                    handleChangeStatus={handleChangeStatus}
                                  />
                                )}

                                {uploadType === "textUpload" && (
                                  <FormBox
                                    Large
                                    style={{ marginBottom: "-10px" }}
                                  >
                                    <CustomTextarea
                                      Edit
                                      rows={6}
                                      placeholder="텍스트를 입력해주세요."
                                      value={textUpload}
                                      onChange={(e) =>
                                        setTextUpload(e.target.value)
                                      }
                                      status="valid"
                                    />
                                  </FormBox>
                                )}
                              </div>
                            )}
                          </>
                        )}
                        {interviewModeType === "explanation" && (
                          <FormBox Large>
                            <CustomTextarea
                              Edit
                              rows={6}
                              placeholder="텍스트를 입력해주세요."
                              value={businessDescription}
                              onChange={(e) =>
                                setBusinessDescription(e.target.value)
                              }
                              status="valid"
                            />
                          </FormBox>
                        )}
                      </TabContent5Item>
                    </div>
                  </>
                )}

                {interviewModeType !== "explanation" &&
                  messages?.length > 0 &&
                  !isLoadingMessage && (
                    <ButtonContainer>
                      <Button
                        BlueOutline
                        Large
                        Fill
                        Round
                        // Edit
                        // Large
                        style={{
                          width: "100px",
                          height: "40px",
                          fontSize: "16px",
                        }}
                        onClick={() => {
                          setShowResetPopup(true);
                          setIsEditingAutoDisplayImage(false);
                        }}
                      >
                        내용 변경
                      </Button>
                      {!isEditingAutoDisplayImage && (
                        <Button
                          Primary
                          Round
                          ExLarge
                          Fill
                          style={{
                            width: "100px",
                            height: "40px",
                            fontSize: "16px",
                          }}
                          onClick={() => {
                            handleSubmitPurpose();
                          }}
                        >
                          재생성
                        </Button>
                      )}
                    </ButtonContainer>
                  )}
              </TabContent5>
            )}

            {activeTab === 3 &&
              (completedSteps.includes(2) || completedSteps.includes(3)) && (
                <TabContent5>
                  <div className="content">
                    <TabContent5Item required>
                      <div style={{ height: "20px" }}></div>{" "}
                      <InfoBox>
                        <div
                          style={{
                            fontWeight: "700",
                            marginBottom: "12px",
                            textAlign: "left",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <Body2 style={{ minWidth: 110 }}>콘텐츠 명</Body2>
                          <Body2 style={{ marginLeft: 16 }}>
                            {contentTitle}
                          </Body2>
                        </div>

                        <div style={{ display: "flex", alignItems: "center" }}>
                          <Body3 color="gray600" style={{ minWidth: 110 }}>
                            콘텐츠 타입
                          </Body3>
                          <Body3 color="gray800" style={{ marginLeft: 16 }}>
                            {dataType === "sensor" &&
                              `센서 데이터 연동 전용(${
                                serialCode || "시리얼 넘버"
                              })`}
                            {dataType === "public" && "공공데이터 사용"}
                            {dataType === "both" &&
                              "센서 데이터 연동 전용(시리얼 넘버), 공공데이터 사용"}
                          </Body3>
                        </div>
                      </InfoBox>
                      <ContentAnalysisSection>
                        <ContentOptionsSection>
                          <TabContent5Item>
                            <div
                              className="title"
                              style={{ marginTop: "24px" }}
                            >
                              <H3
                                color="gray800"
                                style={{
                                  textAlign: "left",
                                  marginBottom: "20px",
                                }}
                              >
                                디스플레이 환경에 적합한 디자인 모드를
                                선택하세요{" "}
                              </H3>
                            </div>

                            <OrganismDesignConceptSelector
                              concepts={designConceptsData}
                              selectedConcepts={selectedDesignConcepts}
                              onSelect={handleDesignConceptSelect}
                              onPreview={() => handleTemplatePreview()}
                            />
                          </TabContent5Item>
                        </ContentOptionsSection>
                      </ContentAnalysisSection>
                    </TabContent5Item>
                  </div>
                </TabContent5>
              )}

            {activeTab === 4 &&
              (completedSteps.includes(3) || completedSteps.includes(4)) && (
                <TabContent5>
                  {isLoading ? (
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        minHeight: "200px",
                        alignItems: "center",
                      }}
                    >
                      <AtomPersonaLoader message="콘텐츠 핵심 내용을 AI로 분석하고 있어요" />
                    </div>
                  ) : (
                    <>
                      <div className="content">
                        <TabContent5Item required>
                          <DashedLine />
                          <CompletionContainer>
                            <CompletionIcon>
                              <CheckIcon>
                                <svg
                                  width="28"
                                  height="26"
                                  viewBox="0 0 28 26"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M26.7408 1.07458C27.9568 1.9055 28.269 3.56483 27.438 4.78081L13.7714 24.7808C13.3237 25.4359 12.6076 25.8576 11.8176 25.9314C11.0277 26.0052 10.2458 25.7234 9.68463 25.1625L1.34609 16.8292C0.304367 15.7881 0.30384 14.0997 1.34491 13.0579C2.38599 12.0162 4.07443 12.0157 5.11615 13.0568L11.1813 19.1181L23.0346 1.77179C23.8655 0.555813 25.5249 0.243661 26.7408 1.07458Z"
                                    fill="white"
                                  />
                                </svg>
                              </CheckIcon>
                            </CompletionIcon>

                            <CompletionMessage>
                              <H3
                                color="gray800"
                                style={{
                                  marginBottom: "8px",
                                  marginTop: "16px",
                                }}
                              >
                                {isEditingAutoDisplay
                                  ? `"${contentTitle}" 편집이 완료되었습니다`
                                  : `"${contentTitle}" 이 완료되었습니다`}
                              </H3>
                            </CompletionMessage>
                          </CompletionContainer>

                          <ContentAnalysisSection>
                            <MoleculeAnalysisCard
                              showButton={false}
                              type="template"
                              onButtonClick={() => {
                                setShowPreviewPopup(true);
                              }}
                              values={{
                                deviceInfo: `${selectedDisplay?.deviceTitle} (${selectedDisplay?.deviceSpec?.deviceInch} / ${selectedDisplay?.deviceSpec?.deviceWidth}x${selectedDisplay?.deviceSpec?.deviceHeight} (mm))`,
                                analysisData: autoDisplayFileAnalysis,
                                designConcept:
                                  selectedDesignConcepts[0] || "기본 심플형",
                                dataTypeText:
                                  dataType === "sensor"
                                    ? `센서 데이터 연동 전용(${
                                        serialCode || "시리얼 넘버"
                                      })`
                                    : dataType === "public"
                                    ? "공공데이터 사용"
                                    : "",
                                messages:
                                  interviewModeType === "explanation"
                                    ? businessDescription
                                    : selectedMessage?.translate +
                                      " " +
                                      selectedMessage?.original,
                              }}
                            />
                          </ContentAnalysisSection>
                          <DashedLine />
                        </TabContent5Item>
                      </div>

                      <ButtonContainer>
                        <Button
                          Primary
                          Large
                          Fill
                          style={{
                            // width: "120px",
                            height: "40px",
                            fontSize: "16px",
                          }}
                          onClick={handleGoBack}
                        >
                          {isEditingAutoDisplay
                            ? "편집 완료"
                            : "콘텐츠 생성 완료"}
                        </Button>
                      </ButtonContainer>
                    </>
                  )}
                </TabContent5>
              )}
          </DesignAnalysisWrap>
        </MainContent>
      </ContentsWrap>

      {showSensorPreview && (
        <OrganismInfoDisplayViewCustomPreview
          onClose={handleCloseSensorPreview}
        />
      )}

      {showPopupError && (
        <PopupWrap
          Warning
          title="다시 입력해 주세요."
          message="현재 입력하신 정보는 목적을 생성할 수 없습니다."
          buttonType="Outline"
          confirmText="확인"
          isModal={false}
          onConfirm={() => window.location.reload()}
        />
      )}

      {showPopupFileSize && (
        <PopupWrap
          Warning
          title="파일 크기 초과"
          message="파일 크기는 20MB를 초과할 수 없습니다."
          buttonType="Outline"
          confirmText="확인"
          isModal={false}
          onConfirm={() => setShowPopupFileSize(false)}
        />
      )}

      {showResetPopup && (
        <PopupWrap
          Warning
          title="현재 생성된 메시지가 모두 삭제됩니다"
          message="정말 다시 만들기를 진행하시겠습니까?"
          buttonType="Outline"
          closeText="취소"
          confirmText="다시 만들기"
          isModal={false}
          onCancel={() => {
            setShowResetPopup(false);
          }}
          onConfirm={() => {
            handleResetAllState();
          }}
        />
      )}

      {showCreditPopup && (
        <PopupWrap
          Warning
          title="서비스 이용 안내"
          message="해당 서비스를 이용하시겠습니까?"
          buttonType="Outline"
          closeText="확인"
          isModal={false}
          onCancel={() => {
            setShowCreditPopup(false);
            navigate("/Tool");
          }}
          onConfirm={() => {
            setShowCreditPopup(false);
            navigate("/Tool");
          }}
        />
      )}

      {showPreviewPopup && (
        <>
          <StyledInterviewPopup>
            <div
              style={{
                maxWidth: "700px",
                width: "100%",
                position: "fixed",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                gap: "20px",
                padding: "32px 32px",
                borderRadius: "15px",
                background: "#FFFFFF",
                boxShadow: "4px 4px 30px rgba(0, 0, 0, 0.15)",
              }}
            >
              <div className="header">
                <H4
                  style={{
                    fontSize: "16px",
                    marginBottom: "16px",
                  }}
                >
                  디스플레이 콘텐츠 자세히 보기
                  <span
                    className="close"
                    onClick={() => setShowPreviewPopup(false)}
                  />
                </H4>
                {/* <div
                  style={{
                    width: "100%",
                    height: "1px",
                    backgroundColor: "#E0E4EB",
                    marginBottom: "16px",
                  }}
                /> */}
              </div>

              <div className="content" style={{ textAlign: "left" }}>
                <div style={{ marginBottom: "12px" }}>
                  <Body2
                    color="gray700"
                    style={{ fontWeight: "400", textAlign: "left" }}
                  >
                    콘텐츠 목적
                  </Body2>
                  <DetailBox>
                    <Body2
                      color="gray800"
                      style={{ fontWeight: "400", textAlign: "left" }}
                    >
                      {selectedPurposes.customerList}
                    </Body2>
                  </DetailBox>
                </div>

                <div style={{ marginBottom: "12px" }}>
                  <Body2
                    color="gray700"
                    style={{ fontWeight: "400", textAlign: "left" }}
                  >
                    콘텐츠 방향성
                  </Body2>
                  <DetailContentBox>
                    <Body3 color="gray600">{contentTarget}</Body3>
                  </DetailContentBox>
                </div>

                <div>
                  <Body2
                    color="gray700"
                    style={{ fontWeight: "400", textAlign: "left" }}
                  >
                    콘텐츠 내용
                  </Body2>
                  <DetailContentBox>
                    <Body3
                      color="gray600"
                      style={{ fontWeight: "400", textAlign: "left" }}
                    >
                      {autoDisplayFileAnalysis?.detail}
                    </Body3>
                  </DetailContentBox>
                </div>
              </div>
            </div>
          </StyledInterviewPopup>
        </>
      )}
    </>
  );
};

export default PageCreateInfoDevice;

const DesignAnalysisWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 100px;
  margin-top: 60px;
`;

const InterviewModeSelection = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
  justify-content: flex-start;
  margin-bottom: -30px;

  button {
    flex: 0 0 auto;
    max-width: 200px;
  }

  .button-container {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    margin-top: 20px;
  }
`;

export const CheckCircle = styled.input`
  appearance: none;
  display: block !important;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  cursor: pointer;

  background-image: ${(props) =>
    props.checked
      ? `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'%3E%3Ccircle cx='12' cy='12' r='12' fill='%23226FFF'/%3E%3Cpath d='M6.76562 12.4155L9.9908 15.6365L17.2338 8.36426' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E")`
      : `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'%3E%3Ccircle cx='12' cy='12' r='11.5' stroke='%23E0E4EB'/%3E%3C/svg%3E")`};
  transition: background-image 0.3s ease-in-out;

  + label {
    cursor: pointer;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;

    + label {
      cursor: not-allowed;
      opacity: 0.5;
    }
  }
`;

const StyledInterviewPopup = styled(InterviewPopup)`
  .markdown-body {
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      margin-top: 0px;
      margin-bottom: 12px;
      color: ${palette.gray800};
      font-weight: 600;
    }
    p,
    li,
    span {
      line-height: 1.55;
    }
    p {
      margin-bottom: 8px;
    }
    h1 {
      font-size: 24px;
    }
    h2 {
      font-size: 20px;
    }
    h3 {
      font-size: 18px;
    }
  }
  .core-value-section h2:nth-of-type(4) ~ p:last-of-type {
    margin-bottom: 12px !important;
  }

  h2:nth-of-type(4) ~ h2:nth-of-type(5) {
    margin-top: 20px;
  }
`;

const InfoBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 20px;
  border: 1px solid ${palette.outlineGray};
  border-radius: 10px;
  // background: ${palette.gray100};
  width: 100%;
  text-align: left;
`;

const ContentAnalysisSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  margin: 24px 0 0px 0;
  width: 100%;
`;

const ContentOptionsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const ButtonContainer = styled.div`
  display: flex;
  // justify-content: space-between;
  align-items: center;
  gap: 12px;
`;

const CompletionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin: 32px auto;
  text-align: center;
  width: 100%;
`;

const CompletionIcon = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: ${palette.primary};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CheckIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const CompletionMessage = styled.div`
  text-align: center;
  max-width: 400px;
`;

const DashedLine = styled.div`
  width: 100%;
  height: 1px;
  border-top: 2px solid ${palette.gray300};
  margin: 0px;
  margin-top: 32px;
  margin-bottom: 36px;
`;

const DetailBox = styled.div`
  background: ${palette.gray100};
  border-radius: 8px;
  padding: 12px 16px;
`;

const DetailContentBox = styled.div`
  background: ${palette.gray100};
  border-radius: 8px;
  padding: 12px 16px;
`;

const RadioCardGroup = styled.div`
  display: flex;
  gap: 20px;
  width: 100%;
`;

const RadioCard = styled.label`
  flex: 1;
  border: 1.5px solid ${({ checked }) => (checked ? "#4F8CFF" : "#E0E4EB")};
  background: ${({ checked }) =>
    checked ? "rgba(34, 111, 255, 0.1);" : "#fff"};
  border-radius: 14px;
  padding: 22px 24px 18px 24px;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  transition: border 0.2s;
  align-items: flex-start;
`;

const RadioInput = styled.input`
  display: none;
`;

const RadioTitle = styled.div`
  font-size: 17px;
  font-weight: 700;
  color: #222;
  display: flex;
  align-items: center;
  gap: 4px;
`;

const RadioDesc = styled.div`
  font-size: 14px;
  color: #888;
  margin-top: 6px;
  font-weight: 400;
  margin-left: 32px;
`;

const CustomRadio = styled.span`
  display: inline-block;
  width: 22px;
  height: 22px;
  border: 2px solid ${({ checked }) => (checked ? "#4F8CFF" : "#C8D1E1")};
  border-radius: 50%;
  margin-right: 10px;
  position: relative;
  background: #fff;
  transition: border 0.2s;
  &::after {
    content: "";
    display: ${({ checked }) => (checked ? "block" : "none")};
    width: 12px;
    height: 12px;
    background: #4f8cff;
    border-radius: 50%;
    position: absolute;
    top: 3px;
    left: 3px;
  }
`;

const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
`;

const Label = styled.label`
  color: #464c53;
  font-size: 15px;
  font-family: Pretendard;
  font-weight: 400;
  line-height: 22.5px;
  text-align: left;
`;

const AddDisplaySection = styled.div`
  // padding: 20px;
  border-radius: 10px;
  border: none;
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
`;

const RadioGroup = styled.div`
  display: flex;
  gap: 32px;
  margin-bottom: 10px;
`;

const RadioButton = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 17px;
  font-family: Pretendard;
  font-weight: 500;
  color: ${(props) => (props.checked ? "#256EF4" : "#464c53")};
  cursor: pointer;
  input[type="radio"] {
    accent-color: #256ef4;
    width: 20px;
    height: 20px;
    margin-right: 4px;

    &:disabled {
      cursor: not-allowed;
    }
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const InputRow = styled.div`
  display: flex;
  gap: 20px;
  margin-bottom: 0;
`;

const HalfInputGroup = styled(InputGroup)`
  flex: 1;
`;

const DoubleSelectRow = styled.div`
  display: flex;
  gap: 32px;
  margin-top: 32px;
`;
const HalfSelectBox = styled(SelectBox)`
  flex: 1;
`;
